// ─────────────────────────────────────────────────────────────────────────────
// fase60 — CUENTAS INTERNAS / VITRINA: exclusión FINANCIERA (espejo del
// composer, src/helpers/internal-accounts.ts — si la lista cambia, cambiarla
// EN LOS DOS).
//
// Las cuatro cuentas sembradas por `sembrar-vitrina.mjs` tienen 36 meses de
// tenencias, transacciones e intereses SINTÉTICOS. Son muestrario y banco de
// pruebas: no son una métrica de nada. Sin este filtro, la página Tenencias
// las sumaría al AUM, encabezarían el donut de concentración con su email a
// la vista, y el espejo de swaps valuaría sus swaps sintéticos con precios
// reales — un contrafactual ficticio contaminando la curva.
//
// OJO con la distinción respecto de la exclusión de MÉTRICAS DE USO
// (pages/metrics): aquélla es amplia (todo admin navegando no es
// comportamiento de inversor). Ésta es quirúrgica: SOLO cuentas cuyas
// tenencias son 100% sintéticas. Un admin con plata real seguiría contando
// en el AUM — la plata real es real sea de quien sea.
// ─────────────────────────────────────────────────────────────────────────────

// Uids DETERMINISTAS de las vitrinas (los asigna crear-cuentas-vitrina.mjs).
export const INTERNAL_ACCOUNT_UIDS = new Set<string>([
  'vitrina-satoshi',
  'vitrina-finney',
  'vitrina-saylor',
]);

// Emails de TODAS las cuentas internas (las tres vitrinas + la admin sembrada;
// el uid de la admin es un auto-id de Firebase, por eso también se filtra por
// email — el loader de Tenencias ya carga el email de cada uid).
export const INTERNAL_ACCOUNT_EMAILS = new Set<string>([
  'damian.prato@yieldbox.me',
  'satoshi@yieldbox.me',
  'finney@yieldbox.me',
  'saylor@yieldbox.me',
]);

// Emails de cuentas de USO interno para las métricas de uso (misma lista que
// web/app metrics-exclusion.ts y composer usage.service — cuatro lugares).
// damian.prato no figura: cae por isAdmin === true, como todos los admins.
export const METRICS_INTERNAL_EMAILS: string[] = [
  'satoshi@yieldbox.me',
  'finney@yieldbox.me',
  'saylor@yieldbox.me',
];

/** ¿La cuenta es interna a efectos FINANCIEROS? (uid determinista o email en
 *  la lista). `email` puede venir vacío para uids sin doc: solo decide el uid. */
export function isInternalAccount(uid: string, email?: string | null): boolean {
  if (INTERNAL_ACCOUNT_UIDS.has(uid)) return true;
  const e = String(email ?? '').toLowerCase();
  return e !== '' && INTERNAL_ACCOUNT_EMAILS.has(e);
}
